import type { FieldDiaryEntry } from '../types';

export const MONTH_NAMES = [
	'Janeiro',
	'Fevereiro',
	'Março',
	'Abril',
	'Maio',
	'Junho',
	'Julho',
	'Agosto',
	'Setembro',
	'Outubro',
	'Novembro',
	'Dezembro',
];

export interface CalendarDay {
	day: number;
	isCurrentMonth: boolean;
	date: Date;
}

export function buildCalendarDays(year: number, month: number): CalendarDay[] {
	const firstDay = new Date(year, month - 1, 1).getDay();
	const daysInMonth = new Date(year, month, 0).getDate();
	const daysInPrevMonth = new Date(year, month - 1, 0).getDate();
	const days: CalendarDay[] = [];

	for (let i = firstDay - 1; i >= 0; i--) {
		days.push({
			day: daysInPrevMonth - i,
			isCurrentMonth: false,
			date: new Date(year, month - 2, daysInPrevMonth - i),
		});
	}
	for (let d = 1; d <= daysInMonth; d++) {
		days.push({ day: d, isCurrentMonth: true, date: new Date(year, month - 1, d) });
	}
	const remaining = 42 - days.length;
	for (let d = 1; d <= remaining; d++) {
		days.push({ day: d, isCurrentMonth: false, date: new Date(year, month, d) });
	}
	return days;
}

export function buildEntriesByDay(entries: FieldDiaryEntry[]): Record<number, FieldDiaryEntry[]> {
	const map: Record<number, FieldDiaryEntry[]> = {};
	for (const entry of entries) {
		const day = Number(entry.date.slice(8, 10));
		if (!map[day]) map[day] = [];
		map[day].push(entry);
	}
	return map;
}
